export enum ShippingsActionTypes {
  GET_LIST_SHIPPINGS_SUCCESS = "SHIPPINGS_GET_LIST_SUCCESS",
  GET_LIST_SHIPPINGS_ERROR = "SHIPPINGS_GET_LIST_ERROR",
  GET_LIST_SHIPPINGS = "SHIPPINGS_GET_LIST",
  GET_SHIPPING = "GET_SHIPPING",
  GET_SHIPPING_SUCCESS = "GET_SHIPPING_SUCCESS",
  GET_SHIPPING_ERROR = "GET_SHIPPING_ERROR",
  UPDATE_SHIPPING = "UPDATE_SHIPPING",
  UPDATE_SHIPPING_SUCCESS = "UPDATE_SHIPPING_SUCCESS",
  UPDATE_SHIPPING_ERROR = "UPDATE_SHIPPING_ERROR",
  UPDATE_STATUS_SHIPPING = "UPDATE_STATUS_SHIPPING",
  UPDATE_STATUS_SHIPPING_SUCCESS = "UPDATE_STATUS_SHIPPING_SUCCESS",
  UPDATE_STATUS_SHIPPING_ERROR = "UPDATE_STATUS_SHIPPING_ERROR",
  UPDATE_DELIVERY_SHIPPING = "UPDATE_DELIVERY_SHIPPING",
  UPDATE_DELIVERY_SHIPPING_SUCCESS = "UPDATE_DELIVERY_SHIPPING_SUCCESS",
  UPDATE_DELIVERY_SHIPPING_ERROR = "UPDATE_DELIVERY_SHIPPING_ERROR",
  DELETE_SHIPPING = "DELETE_SHIPPING",
  DELETE_SHIPPING_SUCCESS = "DELETE_SHIPPING_SUCCESS",
  DELETE_SHIPPING_ERROR = "DELETE_SHIPPING_ERROR",
  DOWNLOAD_SHIPPINGS_LIST = "DOWNLOAD_SHIPPINGS_LIST",
  DOWNLOAD_SHIPPINGS_LIST_SUCCESS = "DOWNLOAD_SHIPPINGS_LIST_SUCCESS",
  DOWNLOAD_SHIPPINGS_LIST_ERROR = "DOWNLOAD_SHIPPINGS_LIST_ERROR",
}
